export default "__VITE_ASSET__BofnjQY___";